import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const DecreaseResolutionIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 36 36" {...props}>
      <g transform="rotate(180, 18, 18)">
        {/* Rounded square with open top-left and bottom-right (rotated) */}
        <path
          d="M12 6H9a3 3 0 0 0-3 3v15a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-3"
          fill="none"
          stroke="currentColor"
          strokeWidth={props.strokeWidth || 2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        {/* Diagonal arrow pointing toward bottom-left corner (rotated) */}
        <path
          d="M16 16L27 5"
          fill="none"
          stroke="currentColor"
          strokeWidth={props.strokeWidth || 2}
          strokeLinecap="round"
        />

        {/* Arrowhead (rotated) */}
        <path
          d="M20 5h7v7"
          fill="none"
          stroke="currentColor"
          strokeWidth={props.strokeWidth || 2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
};

export default DecreaseResolutionIcon;
